import apiV2 from "api-v2";
import type {
	ComplianceQuestionsResponse,
	SaveComplianceQuestionsRequest,
	ComplianceGrid,
	SaveComplianceGridRequest,
	ComplianceStatus,
} from "../types/compliance";
import { unwrap } from "newui/utils/apiResponse";

const complianceBase = (rfxId: number): string =>
	`/rfx/${rfxId}/evaluation/compliance`;

// --- Questions (contract rows 6 & 7) ---

export const getComplianceQuestions = async (
	rfxId: number
): Promise<ComplianceQuestionsResponse> => {
	const response = await apiV2.get(`${complianceBase(rfxId)}/questions`);
	return unwrap<ComplianceQuestionsResponse>(response.data);
};

export const saveComplianceQuestions = async (
	rfxId: number,
	payload: SaveComplianceQuestionsRequest
): Promise<ComplianceQuestionsResponse> => {
	const response = await apiV2.put(
		`${complianceBase(rfxId)}/questions`,
		payload
	);
	return unwrap<ComplianceQuestionsResponse>(response.data);
};

// --- Skip (contract row 10) ---

export const skipCompliance = async (rfxId: number): Promise<void> => {
	await apiV2.post(`${complianceBase(rfxId)}/skip`);
};

// --- Grid (Task 009) ---

export const getComplianceGrid = async (
	rfxId: number
): Promise<ComplianceGrid> => {
	const response = await apiV2.get(`${complianceBase(rfxId)}/grid`);
	return unwrap<ComplianceGrid>(response.data);
};

export const saveComplianceGrid = async (
	rfxId: number,
	payload: SaveComplianceGridRequest
): Promise<ComplianceGrid> => {
	const response = await apiV2.put(`${complianceBase(rfxId)}/grid`, payload);
	return unwrap<ComplianceGrid>(response.data);
};

// --- Status (contract row 11; Task 010) ---

export const getComplianceStatus = async (
	rfxId: number
): Promise<ComplianceStatus> => {
	const response = await apiV2.get(`${complianceBase(rfxId)}/status`);
	return unwrap<ComplianceStatus>(response.data);
};
